{
  function handleFirstTab (e) {
    if (e.keyCode === 9) {
      document.body.classList.add('user-is-tabbing')
    }
  }
  window.addEventListener('keydown', handleFirstTab)
}
